import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";
import { deleteSociety } from "src/actions/societyAction";
import ConfirmBox from "src/views/category/CategoryListView/ConfirmBox";
import {
  Box,
  IconButton,
  SvgIcon,
} from "@mui/material";
import {
  Edit as EditIcon,
  Trash2 as Trash2Icon,
} from "react-feather";
import { useSelector } from "react-redux";

function Results({ className, ...rest }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
const [selectedSociety, setSelectedSociety] = React.useState(null);

const handleDeleteOpen = (row) => {
  setSelectedSociety(row);
  setOpen(true);
};

const handleDeleteClose = () => {
  setOpen(false);
  setSelectedSociety(null);
};

const handleDelete = async () => {
  try {
    await dispatch(deleteSociety(selectedSociety.societyId));
    handleDeleteClose();
  } catch (err) {
    console.error(err);
  }
};

const societyInfo = (
  useSelector((state) => state?.society?.societyInfo) || []
).filter((row) => row.societyId)
.sort((a, b) => b.societyId - a.societyId);

  const columns = [
    {
      field: "societyId",
      headerName: "Society Id",
      width: 90,
    },
    {
      field: "societyName",
      headerName: "Society Name",
      width: 280,
    },
    {
      field: "area",
      headerName: "Area",
      width: 220,
    },
    {
      field: "city",
      headerName: "City",
      width: 150,
    },
    {
      field: "state",
      headerName: "State",
      width: 150,
    },
    {
      field: "pinCode",
      headerName: "Pin Code",
      width: 120,
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="cellAction">

            <Tooltip title="Edit Society">
              <IconButton
                onClick={() =>
                  navigate(
                    "/app/management/edit/society",
                    {
                      state: params.row,
                    }
                  )
                }
              >
                <SvgIcon fontSize="small">
                  <EditIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete Society">
              <IconButton
              onClick={() => handleDeleteOpen(params.row)}
              >
                <SvgIcon fontSize="small">
                  <Trash2Icon />
                </SvgIcon>
              </IconButton>
            </Tooltip>

          </div>
        );
      },
    },
  ];

return (
  <>
    <Box
      sx={{
        height: 500,
        width: "100%",
        marginTop: "2em",
      }}
    >
      <DataGrid
        rows={societyInfo}
        columns={columns}
        getRowId={(row) => row.societyId}
        pageSize={10}
        rowsPerPageOptions={[10]}
      />
    </Box>

    <ConfirmBox
      open={open}
      closeDialog={handleDeleteClose}
      deleteFunction={handleDelete}
      title={selectedSociety ? selectedSociety.societyName : ""}
    />
  </>
);
}

Results.propTypes = {
  className: PropTypes.string,
};

Results.defaultProps = {};

export default Results;